import domready from 'domready';
domready(function () {
  var updateSeason = function (seasonElements, season) {
    Array.prototype.forEach.call(seasonElements, function (el) {
      if (el.dataset.season !== season) {
        el.classList.remove("season-trigger-action--visible");
      } else {
        el.classList.add("season-trigger-action--visible");
      }
    });
  };
  var seasonTriggers = document.getElementsByClassName("season-trigger");
  if (seasonTriggers.length > 0) {
    var activeSeason = seasonTriggers[0].value;
    var seasonElements = document.querySelectorAll("[data-season]");
    updateSeason(seasonElements, activeSeason);
    Array.prototype.forEach.call(seasonTriggers, function (trigger) {
      trigger.addEventListener("change", function (event) {
        var newSeason = event.target.value;
        updateSeason(seasonElements, newSeason);
        updateSeasonTriggers(newSeason);
      });
    });
    var updateSeasonTriggers = function (valueToSet) {
      Array.prototype.forEach.call(seasonTriggers, function (trigger) {
        trigger.value = valueToSet;
      });
    };
  }
});
